(function($){
    $(document).ready(function() {
      if ($('#Deferred-Poster-Modal-23680145850455').length > 0 && $(window).width() < 992) {
        $('.video-section__poster').click();
      } else if ($('#Deferred-Poster-Modal-23680141164631').length > 0 && $(window).width() > 992) {
        $('#Deferred-Poster-Modal-23680141164631').click();
      }
      

      //kostily for slider buttons
      $('button[name="previous"]').on('click', function() {
        $('button[aria-current="true"]').closest('li').prev().find('button').trigger('click');
      });
      $('button[name="next"]').on('click', function() {
        $('button[aria-current="true"]').closest('li').next().find('button').trigger('click');
      });

      $('.close_icon').on('click', function() {
        $('.mobile-facets__wrapper summary').click();  
      })

      $('.sort_toggler').on('click', function(e) {
        e.preventDefault();
        $('.sorting_option').toggleClass('active');
      });
      
      $('.select__sorting a').on('click', function(e) {
        e.preventDefault();
        let val = $(this).closest('li').attr('value');
        $('[name="sort_by"]').val(val).change();
        $('#FacetSortDrawerForm').submit();
      })
      if ( $(window).width() < 767 ) {
        var swiper = new Swiper('.swiper', {
          loop: true,                        
          slidesPerView: 1,
          centeredSlides : true,
          spaceBetween: 7, 
        });
      }

      function getQueryParam(param) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get(param);
      }
      
      // get value GET-param "action"
      const actionParam = getQueryParam("tab");
      if ( actionParam ) {
        if (actionParam === "privacy") {
          $('.contact-privacy-policy > a').trigger('click');
        } else if (actionParam === "terms") {
          $('.contact-terms-conditions > a').trigger('click');
        } else if( actionParam === 'shipping') {
          $('.contact-shipping-returns > a').trigger('click');
        }
      }


      //code for back scrolling
       if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
        var eventName = isOnIOS ? "pagehide" : "beforeunload";
        window.addEventListener(eventName, (event) => {
          var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    
          var centerX = windowWidth / 2;
          var centerY = windowHeight / 2;
          
          var elementsInCenter = document.elementsFromPoint(centerX + 100, centerY);
          let centeredProductId = $(elementsInCenter[0])
                                  .closest('li.grid__item')
                                  .find('.card-wrapper')
                                  .attr('data-id');
          
          if ( ! centeredProductId ) {
            centeredProductId = $('li.grid__item:last-child').find('.card-wrapper').attr('data-id');
          }
          
          var url = new URL(location.href);
          url.searchParams.set("IdToScroll", centeredProductId);
          var newURL = url;
          alert(centeredProductId);
          history.replaceState({}, '', newURL);
        
        
      });
      
      var url = new URL(location.href);
      // var IdToScroll = localStorage.getItem('IdToScroll');
      var IdToScroll = url.searchParams.get("IdToScroll");
      if ( IdToScroll ) {
        if ( $('body.template-collection').length < 1 ) return false;
        
        let toScroll = $(`.card-wrapper[data-id="${IdToScroll}"]`).closest('li.grid__item');
        if ( toScroll ) {
          var windowHeight = $(window).height();
          var elementHeight = toScroll.outerHeight();
          var scrollPosition = toScroll.offset().top - (windowHeight / 2) + (elementHeight / 2);
          $('html, body').animate({
              scrollTop: scrollPosition
          }, 500);
        }
        
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete("IdToScroll");
        const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
        history.replaceState(null, "", newUrl);
      }

      if ( $('.template-product variant-radios').length > 0 && $('variant-radios [type="radio"]').length > 1 ) {
        
        $('.template-product .product-variant-id').val('');
        $('.template-product .product-form__submit').addClass('disabled');

        $('variant-radios fieldset').each(function() {
          let countInputs = $(this).find('input[type="radio"]');
          if ( countInputs.length === 1 ) {
            $(this).find('.form__options label').click();
            $(this).closest('fieldset').hide();
          }
        });
      }

     
      
      $('.template-product .product-variant-id').on('change', function(){
        if ( $('.template-product .product-variant-id').val() === '' ) {
          $('.template-product .product-form__submit').addClass('disabled');
        } else {
          $('.template-product .product-form__submit').find('.-light').text('Add to bag');
          $('.template-product .product-form__submit').find('.-dark').text('Add to bag');
          $('.template-product .product-form__submit').removeClass('disabled');
        }
        
      })
      $('.template-product .product-form__submit.disabled').on('click', function(e) {
        if ( $(this).hasClass('disabled') ) {
           e.preventDefault();
          
          $(this).find('.-light').text('Please choose Size');
          $(this).find('.-dark').text('Please choose Size');
        }
       
      })
      
      if ( $('select.tab-title').length > 0 ) {
        $('select.tab-title').select2({
            minimumResultsForSearch: -1
        });
      }

      $('select.tab-title').on('change', function(e) {
        e.preventDefault();
        let valueOfCurrent = $(this).find('option:selected').attr('data-option');

        $('.template-suffix-contact .tab-content').removeClass('active');
        $(`#${valueOfCurrent}`).addClass('active');
      });

      
      
    });
})(jQuery);